import {
    createSlice,
    createAsyncThunk,
    createEntityAdapter,
    createSelector,
} from '@reduxjs/toolkit'
import { getNotificationsList, markNotificationRead } from './notificationApi'

const notificationAdapter = createEntityAdapter()

export const notificationSelector = notificationAdapter.getSelectors(state => state.notifications)
export const { selectAll } = notificationAdapter.getSelectors(state => state.notifications)

const initialState = notificationAdapter.getInitialState({
    isLoading: false,
    isError: false,
})

export const getNotifications = createAsyncThunk('notification/list', async (arg, thunkAPI) => {
    try {
        const response = await getNotificationsList()
        return response.data
    } catch (error) {
        return thunkAPI.rejectWithValue(error)
    }
})

export const markRead = createAsyncThunk('notification/read', async (arg, thunkAPI) => {
    try {
        const response = await markNotificationRead(arg)
        return response.data
    } catch (error) {
        return thunkAPI.rejectWithValue(error)
    }
})

const updateRead = (state, { ids, isRead }) => {
    return [
        ...ids.map(i => {
            return {
                id: i,
                changes: {
                    ...state.entities[i],
                    isRead,
                },
            }
        }),
    ]
}

export const notificationSlice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {
        add: (state, { payload }) => {
            notificationAdapter.addOne(state, payload)
        },
    },
    extraReducers: builder => {
        builder.addCase(getNotifications.pending, state => {
            state.isLoading = true
            state.isError = false
        })
        builder.addCase(getNotifications.fulfilled, (state, { payload }) => {
            notificationAdapter.setAll(state, payload.data)
            state.isLoading = false
        })
        builder.addCase(getNotifications.rejected, state => {
            state.isLoading = false
            state.isError = true
        })
        builder.addCase(markRead.pending, (state, { meta }) => {
            notificationAdapter.updateMany(
                state,
                updateRead(state, { ids: meta.arg, isRead: true })
            )
        })
        builder.addCase(markRead.rejected, (state, { meta }) => {
            notificationAdapter.updateMany(
                state,
                updateRead(state, { ids: meta.arg, isRead: false })
            )
        })
    },
})

export const { add } = notificationSlice.actions

export default notificationSlice.reducer

export const hasUnreadSelector = createSelector(notificationSelector.selectAll, notifications =>
    Boolean(notifications.filter(d => !d.isRead).length)
)
